<template>
  <page-content title="" :back-button="true">
    <br />
    <div class="access-denied-page">
      <img src="@/assets/icons/hand.svg" alt="Image" class="image" />
      <h3 class="title">Akses Ditolak</h3>
      <p class="description">
        Maaf, Anda tidak memiliki akses pada halaman yang dituju.
      </p>
    </div>
  </page-content>
</template>

<script>
export default {
  name: "access-denied",
};
</script>
